import { Link } from 'react-router-dom';
import { UserI } from 'app/utils/userSlice';
import { Search } from 'app/components';

import { Logo } from 'Header/Logo';
import { UserMenu } from 'UserMenu/UserMenu';

import styles from 'Header/Header.module.scss';

type HeaderT = {
  user: UserI | null;
  withSearch?: boolean;
  setInitCenter: React.Dispatch<React.SetStateAction<number[]>>;
};
export const Header = ({ user, withSearch = false, setInitCenter }: HeaderT) => {
  return (
    <header className={styles.header} data-search={withSearch}>
      <div className={styles.logo_container}>
        <Link to="/">
          <Logo />
        </Link>
      </div>
      {user && withSearch && <Search aligment="center" setInitCenter={setInitCenter} />}
      {user && <UserMenu user={user} />}
    </header>
  );
};
